import axios from '../../axios';

const path = 'animals';

const service = {
  fetchAnimals(params) {
    return axios({ method: 'get', url: path, params });
  },

  fetchAnimal(id, params) {
    return axios({ method: 'get', url: `${path}/${id}`, params });
  },

  fetchAnimalsTags(params) {
    return axios({ method: 'get', url: `${path}/tag-data`, params });
  },

  fetchAnimalTags(id, params) {
    return axios({ method: 'get', url: `${path}/${id}/tag-data`, params });
  },

  fetchStockTypes(id, params) {
    return axios({ method: 'get', url: `${path}/stock-types`, params });
  },

  async updateAnimals(payload) {
    return axios({ method: 'put', url: path, data: payload });
  },

  async updateAnimal({ id, data }) {
    return axios({ method: 'put', url: `${path}/${id}`, data });
  },

  async deleteManyAnimals(ids) {
    return axios({ method: 'delete', url: `${path}/bulk`, data: ids });
  }
};

export default service;
